import { create } from "zustand";
import { persist } from "zustand/middleware";

interface ThemeState {
  isDarkMode: boolean;
  toggleDarkMode: () => void;
  setDarkMode: (isDark: boolean) => void;
}

const applyThemeClass = (isDark: boolean) => {
  if (isDark) {
    document.documentElement.classList.add("dark");
  } else {
    document.documentElement.classList.remove("dark");
  }
};

const useThemeStore = create<ThemeState>()(
  persist(
    (set) => ({
      isDarkMode: false,
      toggleDarkMode: () =>
        set((state) => {
          const newValue = !state.isDarkMode;
          applyThemeClass(newValue);
          return { isDarkMode: newValue };
        }),
      setDarkMode: (isDark: boolean) => {
        applyThemeClass(isDark);
        set({ isDarkMode: isDark });
      },
    }),
    {
      name: "alchemist-theme",
      onRehydrateStorage: () => (state) => {
        // Apply theme class when store is rehydrated from localStorage
        if (state) {
          applyThemeClass(state.isDarkMode);
        }
      },
    }
  )
);

export default useThemeStore;

